import { isLocalDevelopmentHost } from '@nwm-oss/auth-core/environment';

export type WorkspaceRuntimeMode = 'embedded' | 'standalone-local' | 'standalone-disabled';

export interface WorkspaceRuntimeInput {
  readonly search: string;
  readonly hostname: string;
}

export interface WorkspaceRuntime {
  readonly mode: WorkspaceRuntimeMode;
  readonly isEmbedded: boolean;
  readonly isLocalStandaloneHost: boolean;
}

export function resolveWorkspaceRuntime(input: WorkspaceRuntimeInput): WorkspaceRuntime {
  const isEmbedded = new URLSearchParams(input.search).get('embedded') === '1';
  const isLocalStandaloneHost = isLocalDevelopmentHost(input.hostname);

  if (isEmbedded) {
    return {
      mode: 'embedded',
      isEmbedded: true,
      isLocalStandaloneHost,
    };
  }

  if (isLocalStandaloneHost) {
    return {
      mode: 'standalone-local',
      isEmbedded: false,
      isLocalStandaloneHost: true,
    };
  }

  return {
    mode: 'standalone-disabled',
    isEmbedded: false,
    isLocalStandaloneHost: false,
  };
}
